"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAuditLogDto = instanceOfAuditLogDto;
exports.AuditLogDtoFromJSON = AuditLogDtoFromJSON;
exports.AuditLogDtoFromJSONTyped = AuditLogDtoFromJSONTyped;
exports.AuditLogDtoToJSON = AuditLogDtoToJSON;
exports.AuditLogDtoToJSONTyped = AuditLogDtoToJSONTyped;
const AuditEntityType_1 = require("./AuditEntityType");
const ProfileNameDto_1 = require("./ProfileNameDto");
/**
 * Check if a given object implements the AuditLogDto interface.
 */
function instanceOfAuditLogDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('entityType' in value) || value['entityType'] === undefined)
        return false;
    if (!('entityId' in value) || value['entityId'] === undefined)
        return false;
    if (!('previous' in value) || value['previous'] === undefined)
        return false;
    if (!('current' in value) || value['current'] === undefined)
        return false;
    if (!('changedByProfile' in value) || value['changedByProfile'] === undefined)
        return false;
    if (!('changedByAuth0UserId' in value) || value['changedByAuth0UserId'] === undefined)
        return false;
    return true;
}
function AuditLogDtoFromJSON(json) {
    return AuditLogDtoFromJSONTyped(json, false);
}
function AuditLogDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'entityType': (0, AuditEntityType_1.AuditEntityTypeFromJSON)(json['entityType']),
        'entityId': json['entityId'],
        'previous': json['previous'],
        'current': json['current'],
        'changedByProfile': (0, ProfileNameDto_1.ProfileNameDtoFromJSON)(json['changedByProfile']),
        'changedByAuth0UserId': json['changedByAuth0UserId'],
    };
}
function AuditLogDtoToJSON(json) {
    return AuditLogDtoToJSONTyped(json, false);
}
function AuditLogDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'createdAt': ((value['createdAt']).toISOString()),
        'entityType': (0, AuditEntityType_1.AuditEntityTypeToJSON)(value['entityType']),
        'entityId': value['entityId'],
        'previous': value['previous'],
        'current': value['current'],
        'changedByProfile': (0, ProfileNameDto_1.ProfileNameDtoToJSON)(value['changedByProfile']),
        'changedByAuth0UserId': value['changedByAuth0UserId'],
    };
}
//# sourceMappingURL=AuditLogDto.js.map